// extracted by mini-css-extract-plugin
export var link = "_sl-0";